/** Header cell backgrounds; sticky is on `thead` to preserve rowspan/colspan layout. */
export const RCM_HEAD_ROW1_TH = 'bg-gray-900 text-white';
export const RCM_HEAD_ROW2_TH = 'bg-gray-800 text-white';
